/*
 *  -----------------------------------------------------------------------
 *    <copyright file="add-product-dialog.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useTranslation } from 'hooks';
import Button from 'views/components/core/buttons';
import { CustomDialog, DialogTitle, DialogContent, DialogActions } from 'views/components/core/dialog';

import 'views/components/admin/studies/admin-study.scss';

const AddIndicationsDialog = ({
    open,
    onClose,
    fromAssignDialog,
}: {
    open: boolean;
    onClose: Function;
    fromAssignDialog: boolean;
}) => {
    const { t } = useTranslation();

    const close = (action?: any) => {
        onClose(action);
    };

    return (
        <CustomDialog onClose={close} fullWidth scroll="paper" maxWidth="md" open={open} className="custom-width-popup">
            <DialogTitle id="add-product-modal-title">
                {t(fromAssignDialog ? 'admin:leaveStudy' : 'admin:emptyIndicationList')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={close}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent className="add-product-dialog-content">
                <>
                    <div>
                        {!fromAssignDialog && (
                            <span className="confirm-text">{t('admin:thereAreNoMoreIndicationItemsToAssign')}</span>
                        )}
                        <span className={`${fromAssignDialog ? 'pb' : ''} confirm-text`}>
                            {t('admin:wouldYouLikeToLeaveThisPageToAddMore')}
                        </span>
                    </div>
                </>
            </DialogContent>

            <DialogActions className="add-product dialog-actions flex-end">
                <Button
                    id="add-product-new"
                    text="admin:addOrganizationIndications"
                    secondary
                    onClick={() => {
                        close('go-to-indications');
                    }}
                />
            </DialogActions>
        </CustomDialog>
    );
};

export default AddIndicationsDialog;
